// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3BSOe","clinicsSelect":"TableHeading_clinicsSelect__rC0pf"};